import * as React from "react";

const SVGComponent = ({ width = "26px", height = "20px", color = "#00A692", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.8958 4.21041C15.1934 1.73952 12.9294 0 10.3116 0C7.18383 0 4.62568 2.48522 4.50749 5.58458H4.49916C2.01832 5.58458 0 7.60316 0 10.0837C0 12.4189 1.81956 14.3839 4.14608 14.5653C4.24645 14.577 4.33967 14.5827 4.42967 14.5827H14.7502C17.6448 14.5827 20 12.2278 20 9.33325C20 6.84568 18.272 4.7361 15.8958 4.21059L15.8958 4.21041ZM10.0001 11.6128L6.63323 8.04343L7.55442 7.17457L9.36669 9.09568V4.36687H10.6333V9.09568L12.4455 7.17457L13.3667 8.04343L10.0001 11.6128Z"
      fill={color}
    />
  </svg>
);
export default SVGComponent;